<template>
  <div>
    <b-table
      hover
      :items="items"
      :busy="loading"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BSpinner, BTable } from 'bootstrap-vue'
import * as Services from './services'

export default {
  components: {
    BSpinner,
    BCardCode,
    BTable,
  },
  setup() {
    const { Top5Unit } = Services
    const { data: unitData } = Top5Unit()
    return {
      unitData,
      loading : true
    }
  },
  computed: {
    items() {
      let items = []
      for (let index = 0; index < 5; index++) {
        items.push({
          top_5_unit: !this.unitData[index] ?  '-' : this.unitData[index].division ? this.unitData[index].division : this.unitData[index].division,
          count: !this.unitData[index] ?  '-' : this.unitData[index].count ? this.unitData[index].count : this.unitData[index].count,
        })
      }
      return items
    }
  },
  watch: {
    unitData: function (newVal, oldVal) {
      this.loading = false
    }
  }
}
</script>